import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Constant from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import xls from "../../assets/img/xls.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function Attendance() {
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalItems, setTotalItems] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState("2025-04");
  const fileInputRef = useRef(null);
  // const history = useNavigate();

  // const fetchAttendanceData = async (page, month) => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `http://localhost:1051/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
  //       // `https://api.policicue.com/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
  //     );
  //     const data = response.data.data || [];
  //     setAttendanceData(data);
  //     setTotalItems(response.data.total || 0);
  //   } catch (error) {
  //     console.error("Error fetching attendance data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchAttendanceData = async (page, month) => {
    setLoading(true);
    try {
      const response = await axios.get(
        // `http://localhost:1051/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
        `https://api.policicue.com/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
      );
      const data = response.data.data || [];
      // This is the key line:
      setAttendanceData(data);
      setTotalItems(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAttendanceData(currentPage, selectedMonth);
  }, [currentPage, selectedMonth]);

  const handleNextPage = () => {
    if (currentPage * itemsPerPage < totalItems) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
    setCurrentPage(1);
  };

  const downloadExcel = async () => {
    try {
      const response = await axios.get(
        // `http://localhost:1051/hrms/attendance/download?month=${selectedMonth}`,
        `https://api.policicue.com/hrms/attendance/download?month=${selectedMonth}`,

        {
          responseType: "blob", // This is crucial for handling file downloads
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `attendance_${selectedMonth}.xlsx`);
    } catch (error) {
      console.error("Error downloading the Excel file:", error);
      alert("Failed to download the Excel file. See console for details.");
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // MODIFIED: This function now calls the correct endpoint for uploading attendance data.
  const handleFileUpload = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      console.error("No file selected.");
      return;
    }
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append("file", file);

    try {
      // The API endpoint is updated to the one specified for uploading attendance.
      const response = await axios.post(
        // "http://localhost:1051/hrms/uploadEmployeeExcel",
        "https://api.policicue.com/hrms/uploadEmployeeExcel",

        formData,
        {
          headers: {
            // Axios will set the correct Content-Type with boundary for multipart/form-data
            // So explicitly setting it is often not needed.
          },
        }
      );

      console.log("Response:", response.data);
      // Displaying the success message from the API response
      alert(response.data.message || "Upload successful");
      // Refresh the data on the page to show the newly uploaded information
      fetchAttendanceData(1, selectedMonth);
    } catch (err) {
      console.error("Upload failed", err.response?.data || err);
      // Displaying the error message from the API response if available
      alert(
        err.response?.data?.message ||
          "Upload failed. Please check the console for details."
      );
    }
  };

  return (
    <div className="Payroll">
      <div className="container-fluid my-2">
        <div className="row">
          <main className="mainBodyContainer">
            <div className="row my-2">
              <div className="col-9 py-2 px-3">
                <h4
                  className="text-capitalize"
                  style={{
                    fontFamily: "ErasDemiITC",
                    fontWeight: "bold",
                    marginTop: "1rem",
                    marginLeft: "12px",
                  }}
                >
                  Attendance
                </h4>
              </div>
              <div className="col-3 py-2 px-3 text-end">
                <input
                  type="month"
                  className="form-control"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                />
              </div>
            </div>

            <div className="row my-2">
              <div className="col-12 py-1 px-3">
                <div className="bg-white p-2 rounded-3 shadow-sm">
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <>
                      <table className="table table-striped table-hover">
                        <thead>
                          <tr
                            className="text-uppercase"
                            style={{
                              lineHeight: "15px",
                              fontFamily: "Calibri",
                              fontSize: "14px",
                              color: "#7D90B2",
                              backgroundColor: "#F4F7FC",
                            }}
                          >
                            <th className="py-3">Employee Name</th>
                            <th className="text-center py-3">Employee ID</th>
                            <th className="text-center py-3">Month</th>
                            <th className="text-center py-3">Working Days</th>
                            <th className="text-center py-3">Leave Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          {attendanceData.map((record, index) => (
                            <tr key={`${record.employee_id}-${index}`}>
                              <td>{record.employee_name || "--"}</td>
                              <td className="text-center">
                                {record.employee_id || "--"}
                              </td>
                              <td className="text-center">
                                {record.month || "--"}
                              </td>
                              <td className="text-center">
                                {record.work_days ?? "--"}
                              </td>
                              <td className="text-center">
                                {record.leave_days ?? "--"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className="d-flex justify-content-between align-items-center mt-3 px-2">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                        <span>Page {currentPage}</span>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={handleNextPage}
                          disabled={currentPage * itemsPerPage >= totalItems}
                        >
                          Next
                        </button>
                      </div>

                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={downloadExcel}
                          title="Download Excel Sheet"
                        >
                          <img
                            style={{ width: "50px", height: "50px" }}
                            src={xls}
                            alt="Download Excel"
                          />
                        </button>
                        <div>
                          <input
                            type="file"
                            accept=".xlsx, .xls"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                          />
                          {/* THIS BUTTON TRIGGERS THE MODIFIED handleFileUpload FUNCTION */}
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "#668c4f",
                              color: "white",
                            }}
                            onClick={handleButtonClick}
                          >
                            Upload File
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
